import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import { KioskDistributionModel } from './dto/KioskDistribution.dto';

export class KioskDistributionApi {
  constructor(private client: AxiosInstance) {}

  // KioskDistributionDto === KioskDistributionModel
  fetch(projectId: number): Promise<KioskDistributionModel> {
    return this.client.get(`/api/v1/project/${projectId}/kiosk-distribution`).then(selectApiData);
  }
}
